module.exports = __webpack_public_path__ + "img/dev-tools.e2d9b927.svg";